import React from 'react'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import { Typography } from '@mui/material'

import { AcceptationDialog } from '../../../ui'
import { ModalContext } from '../../../ui/modal/contexts'

export const useSignupDialogs = () => {
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useContext(ModalContext)

  const warnWrongCif = (callback) => {
    const NEDGIA_COLABORADORES_URL = 'https://www.nedgia.es/colaboradores/ser-colaborador'
    const textComponent = (
      <>
        <Typography paragraph>
          {formatMessage({ id: 'pages.signup.notify.wrongCif.description.1' })}
        </Typography>
        {formatMessage({
          id: 'pages.signup.notify.wrongCif.description.2',
        })}{' '}
        <a target="_blank" href={NEDGIA_COLABORADORES_URL} rel="noopener noreferrer">
          {NEDGIA_COLABORADORES_URL}
        </a>{' '}
        {formatMessage({
          id: 'pages.signup.notify.wrongCif.description.3',
        })}
      </>
    )
    open({
      Component: AcceptationDialog,
      data: {
        title: formatMessage({ id: 'pages.signup.notify.wrongCif.title' }),
        textComponent,
        yesText: formatMessage({ id: 'pages.signup.notify.wrongCif.yes' }),
        yesAction: callback,
      },
      type: 'centered',
    })
  }
  const showWelcomeDialog = (callback, isPrescriptor = false) => {
    const NEDGIA_COLABORADORES_EMAIL_LINK = 'mailto:canalacerca@nedgia.es'
    const NEDGIA_COLABORADORES_EMAIL = 'canalacerca@nedgia.es'
    const textComponent = (
      <>
        <Typography variant="h6" gutterBottom>
          {formatMessage({ id: 'pages.signup.notify.welcome.title' })}
        </Typography>

        <Typography paragraph>
          <strong>{formatMessage({ id: 'pages.signup.notify.welcome.subtitle' })}</strong>
        </Typography>

        <Typography paragraph>
          {formatMessage({ id: 'pages.signup.notify.welcome.description' })}
        </Typography>

        <ul>
          <li>{formatMessage({ id: 'pages.signup.notify.welcome.list.1' })}</li>
          <li>{formatMessage({ id: 'pages.signup.notify.welcome.list.2' })}</li>
          {!isPrescriptor && <li>{formatMessage({ id: 'pages.signup.notify.welcome.list.3' })}</li>}
          <li>
            {isPrescriptor
              ? 'Conocer y adherirse a la Oferta Pública (Colaboración comercial a Prescriptores yCampañas al cliente).'
              : formatMessage({ id: 'pages.signup.notify.welcome.list.4' })}
          </li>
          {!isPrescriptor && <li>{formatMessage({ id: 'pages.signup.notify.welcome.list.5' })}</li>}
          {isPrescriptor && <li>{formatMessage({ id: 'pages.signup.notify.welcome.list.8' })}</li>}
          <li>{formatMessage({ id: 'pages.signup.notify.welcome.list.6' })}</li>
          <li>{formatMessage({ id: 'pages.signup.notify.welcome.list.7' })}</li>
        </ul>

        <Typography paragraph>
          <strong>{formatMessage({ id: 'pages.signup.notify.welcome.newUser.title' })}</strong>
        </Typography>

        <Typography paragraph>
          {formatMessage({ id: 'pages.signup.notify.welcome.newUser.description' })}
        </Typography>

        {!isPrescriptor && (
          <Typography paragraph>
            {formatMessage({ id: 'pages.signup.notify.welcome.contact.description' })}{' '}
            <a target="_blank" href={NEDGIA_COLABORADORES_EMAIL_LINK} rel="noopener noreferrer">
              {NEDGIA_COLABORADORES_EMAIL}
            </a>{' '}
            {formatMessage({ id: 'pages.signup.notify.welcome.contact.phone' })}
          </Typography>
        )}
      </>
    )

    open({
      Component: AcceptationDialog,
      data: {
        title: formatMessage({ id: 'pages.signup.notify.welcome.title' }),
        textComponent,
        yesText: formatMessage({ id: 'pages.signup.notify.welcome.button' }),
        yesAction: callback,
      },
      type: 'centered',
      maxWidth: 'sm',
    })
  }

  const notifySuccessfulSignup = (callback) => {
    open({
      Component: AcceptationDialog,
      data: {
        title: formatMessage({ id: 'pages.signup.feedback.1.title' }),
        text: formatMessage({ id: 'pages.signup.feedback.1.text' }),
        yesText: formatMessage({ id: 'global.return' }),
        yesAction: callback,
      },
      type: 'centered',
    })
  }
  const notifySignupFailure = (error) => {
    open({
      Component: AcceptationDialog,
      data: {
        title: formatMessage({ id: 'pages.signup.feedback.2.title' }),
        text: error || formatMessage({ id: 'pages.signup.feedback.2.text' }),
        yesText: formatMessage({ id: 'global.return' }),
      },
      type: 'centered',
    })
  }

  return {
    warnWrongCif,
    showWelcomeDialog,
    notifySignupFailure,
    notifySuccessfulSignup,
  }
}
